<template>
  <div class="sort" :class="{ inactive: $route.query.sort_param !== param }">
    <svg
      v-if="
        ($route.query['sort_param'] === param && $route.query['sort_value'] === 'desc') ||
        $route.query['sort_param'] !== param
      "
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00004 4.49995H7.99993C8.13535 4.49995 8.25257 4.45051 8.35149 4.35153C8.45036 4.25259 8.49999 4.13542 8.49999 4C8.49999 3.86458 8.45038 3.74746 8.35149 3.64838L4.85153 0.148419C4.75264 0.0495823 4.6355 0 4.5 0C4.36449 0 4.24735 0.0495823 4.14838 0.148419L0.648419 3.64838C0.549446 3.74735 0.5 3.86458 0.5 4C0.5 4.13539 0.549446 4.25259 0.648419 4.35153C0.747501 4.45051 0.864644 4.49995 1.00004 4.49995Z"
        fill="#F2F2F2"
      />
    </svg>
    <svg
      v-if="
        ($route.query['sort_param'] === param && $route.query['sort_value'] === 'asc') ||
        $route.query['sort_param'] !== param
      "
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99993 0.500183H1.00004C0.864534 0.500183 0.747392 0.549656 0.648419 0.64852C0.549446 0.747493 0.5 0.864636 0.5 1.00006C0.5 1.13548 0.549446 1.2527 0.648419 1.35162L4.14838 4.85153C4.24746 4.95051 4.3646 5.00006 4.5 5.00006C4.63539 5.00006 4.75264 4.95051 4.85153 4.85153L8.35149 1.35159C8.45036 1.2527 8.49999 1.13548 8.49999 1.00003C8.49999 0.864636 8.45038 0.747493 8.35149 0.648493C8.2526 0.549547 8.13535 0.500183 7.99993 0.500183Z"
        fill="#F2F2F2"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSort',
  props: { param: String },
}
</script>

<style lang="scss" scoped>
.sort {
  background: #277faf;
  width: 25px;
  height: 20px;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 5px 8.5px;
  &.inactive {
    background: #828282;
    svg {
      &:first-of-type {
        margin-bottom: 2px;
      }
    }
  }
}
</style>
